import React, { Component } from 'react';

class App extends Component {
  render() {
    return (
      <main className="app-shell">
        <section className="app-welcome">
          <p className="eyebrow">24 Hours Guaranteed</p>
          <h1>SPA scaffold (dev-only)</h1>
          <p className="lede">
            The public homepage currently routes to the static 3-cycle landing page. This SPA is kept around
            for future componentization and can be viewed via <code>/?spa</code>.
          </p>
          <div className="cta-row">
            <a className="btn btn-primary" href="/landing-3cycles.html" target="_blank" rel="noreferrer">
              View 3-cycle landing
            </a>
          </div>
        </section>
      </main>
    );
  }
}

export default App;
